module.exports = __webpack_public_path__ + "images/Angle-double-left.c3d21b3ce6dac314e99b9c8faf1b121e.svg";